<div class="links">
  <div class="item">
    <a routerLink="/empresa/facturacion"> FACTURACIÓN </a>
  </div>
  @for (item of pages(); track $index) {
    <div class="item">
      <a [routerLink]="'/legales/' + item.slug">{{ item.name }}</a>
    </div>
  }
  <div class="item">
    <a href="tel:8000438422">Línea de denuncia: 800 043 8422</a>
  </div>
  <!-- <div class="item">
    <a routerLink="/empresa/facturacion"> FACTURACIÓN </a>
  </div>
  <div class="item">
    <a routerLink="/politica-de-cookies"> Política de cookies </a>
  </div>
  <div class="item">
    <a routerLink="/politica-anticorrupcion"> Política anticorrupción </a>
  </div>
  <div class="item">
    <a routerLink="/politica-de-seguridad"> Política de seguridad </a>
  </div>
  <div class="item">
    <a routerLink="/codigo-de-etica"> Código de ética </a>
  </div>
  <div class="item">
    <a routerLink="/aviso-de-privacidad"> Aviso de privacidad </a>
  </div>
  <div class="item">
    <a target="_blank" href="https://xamixtli.org/"> Fundación Tracsa </a>
  </div>
  <div class="item">
    <a routerLink="/terminos-y-condiciones"> Términos y condiciones </a>
  </div> -->
</div>
